export const SET_MY_INFO = "SET_MY_INFO";
export const CLEAR_MY_INFO = "CLEAR_MY_INFO";
export const SET_MY_PERMISSION = "SET_MY_PERMISSION";
export const CLEAR_MY_PERMISSION = "CLEAR_MY_PERMISSION";
export const UPDATE_RPM_ALERT_COUNT = "UPDATE_RPM_ALERT_COUNT";
export const UPDATE_SELECTED_ALERT = "UPDATE_SELECTED_ALERT";
export const CLEAR_USER = "CLEAR_USER";
